export enum EQueueType {
	None,
	Enter,
	Damask,
	Return,
}

/** Конфигурация очереди */
export type EQueueConfigType = {
	contactId?: string;
	login?: string;
	/** Пароль для подключения к очереди */
	password?: string | null;
	/** Идентификатор офиса */
	officeId?: number;
	pultId?: string;
	pultName?: string | null;
	queueServerAddress?: string | null;
	/** IP-адрес и порт окна (например, "127.0.0.1:8030") */
	windowIp?: string;
	/** Имя пользователя для подключения к очереди */
	username?: string;
};

export enum WidgetType {
	None,
	Waiting,
	Calling,
	Working,
	OnPause,
	Unknown,
}

export type BeginPauseParamsType = {
	reason: string;
	idQ?: string;
};

export type eQueueStatuses =
	'Offline' | 'Idle' | 'Waiting' | 'Calling' | 'Working' | 'OnPause';
